import { fetchingProduct } from "../fetchingProduct";
import { productAdded } from "../productAdded";

export function handlerCardProduct(container) {
  const cardProducts = container.querySelectorAll(".product-article");

  if (cardProducts.length > 0) {
    cardProducts.forEach((product) => {
      const openVariants = product.querySelector(
          ".product-article__handlers--open-variants"
        ),
        contentVariants = product.querySelector(".product-article__variants"),
        closeVariants = contentVariants?.querySelector(
          ".product-article__variants--close"
        ),
        productOptions = contentVariants?.querySelectorAll(
          ".product-article__variants--ul"
        ),
        addToCart = contentVariants
          ? contentVariants.querySelector(".add-to-cart")
          : product.querySelector(".product-article__handlers--add-to-cart");

      let variantOptions = {},
        dataProduct = null;

      if (closeVariants && contentVariants) {
        closeVariants.addEventListener("click", () => {
          contentVariants.classList.remove("open");
        });
      }

      if (openVariants && contentVariants) {
        const productHandle = contentVariants.getAttribute("handle-product");

        openVariants.addEventListener("click", async () => {
          contentVariants.classList.add("open");

          dataProduct = await fetchProductData(productHandle);
          if (!dataProduct) {
            console.error("No se pudieron cargar los datos del producto.");
          }
        });
      }

      productOptions?.forEach((option) => {
        option.addEventListener("change", () => {
          const typeOption = option.getAttribute("option-name");
          variantOptions[typeOption] = option.value;

          if (dataProduct && dataProduct.variants) {
            const filteredVariant = dataProduct.variants.find((variant) => {
              return Object.keys(variantOptions).every((key) => {
                const optionIndex =
                  Object.keys(variantOptions).indexOf(key) + 1;
                return variant[`option${optionIndex}`] === variantOptions[key];
              });
            });

            if (filteredVariant) {
              addToCart.setAttribute("data-product-id", filteredVariant.id);
              addToCart.classList.add("visible");
            } else {
              addToCart.classList.add("visible");
            }
          } else {
            console.warn("Datos del producto no cargados aún.");
          }
        });
      });

      addToCart?.addEventListener("click", () => {
        const productId = addToCart.getAttribute("data-product-id");
        const loader = addToCart.querySelector(
          ".product-article__action--loader"
        );

        if (!productId) {
          console.error(
            "No se ha seleccionado un producto válido para añadir al carrito."
          );
          return;
        }

        loader.style.display = "block";
        fetchingProduct("/cart/add.js", "POST", "id", productId, 1)
          .then(() => {
            productAdded(product);
            loader.style.display = "none";
          })
          .catch((error) => {
            console.error("Error al añadir producto:", error.message);
            loader.style.display = "none";
          });
      });
    });
  }
}
async function fetchProductData(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);

    if (!response.ok) {
      throw new Error("Error al obtener el producto");
    }

    return await response.json();
  } catch (error) {
    console.error("Error al obtener los datos del producto:", error);
    return null;
  }
}
export function handlerSecondProduct(container) {
  let article = container.querySelectorAll(".product-article-second");
  if (article.length > 0) {
    article.forEach((art) => {
      const selectors = {
        addToCart: art.querySelector(".product-article-second__add-to-cart"),
        variants: art.querySelectorAll(".product-article-second__variants--ul"),
        quantity: art.querySelector(".product-article-second__qty--number"),
        plus: art.querySelector(".product-article-second__qty--button--plus"),
        minus: art.querySelector(".product-article-second__qty--button--minus"),
      };
      let variantOptions = {};
      // LISTENERS
      selectors.minus.addEventListener(
        "click",
        () => selectors.quantity.value--
      );
      selectors.plus.addEventListener(
        "click",
        () => selectors.quantity.value++
      );

      selectors.variants?.forEach((option) => {
        option.addEventListener("change", () => {
          const typeOption = option.getAttribute("option-name");
          variantOptions[typeOption] = option.value;
        });
      });

      selectors.addToCart.addEventListener("click", async () => {
        let productId = selectors.addToCart.getAttribute("data-product-id"),
          dataProduct = null,
          loader = selectors.addToCart.querySelector(
            ".product-article-second__action--loader"
          ),
          filteredVariant;

        // Obtiene los datos del producto
        dataProduct = await fetchProductData(productId);

        if (dataProduct && dataProduct.variants) {
          // Validar que las opciones sean válidas
          const isValid = Object.entries(variantOptions).every(
            ([key, value]) => {
              const productOption = dataProduct.options.find(
                (option) => option.name === key
              );
              return productOption && productOption.values.includes(value);
            }
          );

          if (!isValid) {
            console.error(
              "Las opciones seleccionadas no son válidas. Revisa tus selecciones."
            );
            return;
          }

          // Filtrar la variante basada en las opciones seleccionadas
          filteredVariant = dataProduct.variants.find((variant) => {
            return Object.entries(variantOptions).every(([key, value]) => {
              const optionIndex =
                dataProduct.options.findIndex((option) => option.name === key) +
                1;
              return variant[`option${optionIndex}`] === value;
            });
          });

          if (!filteredVariant) {
            console.error(
              "No se encontró una variante que coincida con las opciones seleccionadas."
            );
            return;
          }

          // Añadir el producto al carrito
          fetchingProduct(
            "/cart/add.js",
            "POST",
            "id",
            filteredVariant.id,
            selectors.quantity.value
          )
            .then(() => {
              productAdded(art);
              loader.style.display = "none";
            })
            .catch((error) => {
              console.error("Error al añadir producto:", error.message);
              loader.style.display = "none";
            });
        }
      });
    });
  }
}
